export enum DocumentsTableNamesEnum {
  'DocumentOverview' = 'DocumentOverview',
  'DocumentStages' = 'DocumentStages',
  'DocumentRevisions' = 'DocumentRevisions',
  'DocumentReadReceiptRequests' = 'DocumentReadReceiptRequests',
}
